
async function loadCartDrawerRelatedProducts() {
  const container = document.getElementById('CartDrawer-RelatedProducts');
  if (!container) return;

  const cart = await fetch('/cart.js').then(r => r.json());
  if (!cart.items.length) {
    container.innerHTML = '';
    return;
  }

  const LIMIT = 4;
  const collectedHandles = new Set();
  let html = '';

  for (const item of cart.items) {
    if (collectedHandles.size >= LIMIT) break;

    const res = await fetch(
      `/recommendations/products?product_id=${item.product_id}&limit=${LIMIT}&section_id=cart-drawer-related-products`
    );

    const text = await res.text();

    // Parse returned HTML
    const temp = document.createElement('div');
    temp.innerHTML = text;

    const products = temp.querySelectorAll('[data-product-handle]');

    for (const product of products) {
      const handle = product.dataset.productHandle;

      if (
        !collectedHandles.has(handle) &&
        !cart.items.some(ci => ci.handle === handle)
      ) {
        collectedHandles.add(handle);
        html += product.outerHTML;
      }

      if (collectedHandles.size >= LIMIT) break;
    }
  }

  container.innerHTML = collectedHandles.size
    ? `<div class="cart-drawer-related">
        <h3 class="related-products__heading inline-richtext">
          You may also like
        </h3>
        <ul class="grid product-grid" role="list">
          ${html}
        </ul>
      </div>`
    : '';
}

// document.addEventListener('cart:refresh', loadCartDrawerRelatedProducts);
document.addEventListener('DOMContentLoaded', loadCartDrawerRelatedProducts);

document.addEventListener('DOMContentLoaded', function () {

    function renderManaPoints(points) {
      console.log('tt2');
      const els = document.querySelectorAll(".mana-points-balance");
      if (!els.length) return;
      console.log('tt3');
      
      const euros = points / 10; // 10 points = €1
      
      els.forEach((el) => {
        el.innerHTML = `
        You have <strong>${points}</strong> Mana Points
        <span class="mana-eq">(Equivalent to €${euros})</span>
        `;
        el.hidden = false;
      });
      console.log('tt4');
    }

    /* 1️⃣ Listen for event (future) */
    document.addEventListener("mana:points:fetched", function (e) {
      renderManaPoints(e.detail.points);
    });

    /* 2️⃣ Fallback if event already fired (past) */
    if (window.manaState && window.manaState.loaded) {
      renderManaPoints(window.manaState.points);
    }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {

    console.log('Cart Updated!', event);
    loadCartDrawerRelatedProducts();
    if (window.manaState && window.manaState.loaded) {
      // 🔥 wait for DOM replacement to finish
      requestAnimationFrame(() => {
        setTimeout(() => {
          renderManaPoints(window.manaState.points);
        }, 50);
      });
    }

    // your custom logic here
    // refreshCustomCartText(event.cartData);

  });

});
